<script setup lang="ts">
import {apiClient} from "@/api/http.ts";
import {onMounted, ref, watch} from "vue";

const props = defineProps({
  entityId: {
    required: true,
    type: Number,
  }
})
type OfferLine = {
  id: number
  title: string
  description?: string,
  opmerking_prijs?: string,
  locatie?: string,
  aantal?: number,
  tarief_extra_deelnemer?: number,
  bedrag?: number,
}
const offerLines = ref<OfferLine[]>([])
const loadOfferLines = async () => {
  if (props.entityId) {
    apiClient.get('wiser/offerteregel?page=1&perPage=25&filters='+encodeURIComponent('inverse-offerteregelonderofferte='+props.entityId)).then((res) => {
      offerLines.value = res.data
    })
  }
}
onMounted(() => {
  loadOfferLines()
})
watch(
  () => props.entityId,
  loadOfferLines
)
</script>

<template>
  <div class="model-list--OfferLine wiser-detail__description offerLines-detail__description" v-if="offerLines.length ?? 0 > 0">
    <h3>Offerteregels</h3>
    <ul class="model-list__items model-list-offerLine">
      <li class="model-list model-list-item">
        <strong>Omschrijving</strong>
        <strong>Opmerking prijs</strong>
        <strong>Locatie</strong>
        <strong>Aantal</strong>
        <strong>Bedrag</strong>
        <strong>Extra deelnemer</strong>
      </li>
      <li v-for="(offerLine, index) in offerLines" :key="index" class="model-list model-list-item">
        <span>{{ offerLine.description }}</span>
        <span>{{ offerLine.opmerking_prijs }}</span>
        <span>{{ offerLine.locatie }}</span>
        <span>{{ Intl.NumberFormat('nl-NL').format(offerLine.aantal ?? 0) }}</span>
        <span>{{ Intl.NumberFormat('nl-NL', { style: "currency", currency: "EUR" }).format(offerLine.bedrag ?? 0) }}</span>
        <span>{{ Intl.NumberFormat('nl-NL', { style: "currency", currency: "EUR" }).format(offerLine.tarief_extra_deelnemer ?? 0) }}</span>
      </li>
    </ul>
  </div>
</template>

<style scoped>

</style>
